var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"href":"/admin","variant":"primary"}},[_vm._v("試験結果一覧")])}
var staticRenderFns = []

export { render, staticRenderFns }